import { Badge } from "@magnetic/badge";

import { Button } from "src/components/buttons";
import { withShowToggle } from "src/components/hoc/withShowToggle";

import { PreviewChangesButtonProps } from "./types";

export const PreviewChanges = withShowToggle(
  ({ handleAction, count = 0 }: PreviewChangesButtonProps) => {
    const eventCount = count ? (
      <Badge.Counter className="event-count" size="sm" value={count} />
    ) : null;

    return (
      <Button
        disabled={!count}
        name="preview-changes"
        kind="secondary"
        onClick={handleAction}
      >
        Preview changes
        {eventCount}
      </Button>
    );
  }
);
